import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * @deprecated This slice is deprecated. Use authorizationSlice instead.
 * @see /home/andrew/Documents/Projects/OwnProjects/eOffice/eOffice.admin/src/app/store/slices/authorizationSlice.ts
 * 
 * Migration guide:
 * - state.user.info -> state.authorization.user
 * - state.user.accessToken -> state.authorization.accessToken
 * - state.user.refreshToken -> state.authorization.refreshToken
 * - state.user.tenantID -> state.authorization.tenantID
 * - state.user.isAdmin -> state.authorization.isAdmin
 */

export type UserRole = 'owner' | 'tenant' | 'none';

interface IUser {
  role: UserRole;
  email: string;
  fullName: string;
  firstName: string;
  avatar: string;
  id: string;
  lastName: string;
  profile_id?: string;
}

interface IUserState {
  info: IUser;
  accessToken: string;
  isAdmin: boolean;
  refreshToken: string;
  tenantID: string;
  isLoading: boolean;
  error: string;
  notificationListener?: any;
  driverReceives?: any;
}

const initialState: IUserState = {
  info: {
    role: 'none',
    email: '',
    fullName: '',
    firstName: '',
    avatar: '',
    id: '',
    lastName: '',
  },
  accessToken: '',
  isAdmin: false,
  refreshToken: '',
  tenantID: '',
  isLoading: false,
  error: '',
};

/**
 * @deprecated Use authorizationSlice instead
 */
export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<IUser>) => {
      state.info = action.payload;
    },
    setUserRole: (state, action: PayloadAction<UserRole>) => {
      state.info.role = action.payload;
    },
    setUserEmail: (state, action: PayloadAction<string>) => {
      state.info.email = action.payload;
    },
    logout: state => {
      state.info = initialState.info;
    },
    connectMessaging: () => {
      // TODO: Implement messaging connection
    },
  },
  // extraReducers закоментовано - буде тестуватися пізніше
  // extraReducers: (builder) => {
  //   builder
  //     .addMatcher(
  //       userApi.endpoints.login.matchFulfilled,
  //       (state, { payload }) => {
  //         if (payload && typeof payload === 'object') {
  //           state.info = payload.user;
  //           state.accessToken = payload.accessToken || '';
  //           state.refreshToken = payload.refreshToken || '';
  //           state.tenantID = payload.tenantID || '';
  //           state.info.role = payload.isAdmin ? 'owner' : 'tenant';
  //           state.isLoading = true;
  //           state.error = '';
  //         }
  //       }
  //     )
  // },
});

/**
 * @deprecated Use selectUserRole from authorizationSlice instead
 */
export const selectUser = (state: any) => state.user.info.role;

/**
 * @deprecated Not implemented in authorizationSlice yet
 */
export const selectNotificationListener = (state: any) =>
  state.user.notificationListener;

/**
 * @deprecated Use selectAuthorizationUser from authorizationSlice instead
 */
export const selectProfile = (state: any) => state.user.info;

/**
 * @deprecated Use selectAuthorizationUser from authorizationSlice instead
 */
export const selectProfileID = (state: any) => state.user.info.profile_id;

/**
 * @deprecated Not implemented in authorizationSlice yet
 */
export const selectDriverReceives = (state: any) => state.user.driverReceives;

/**
 * @deprecated Use actions from authorizationSlice instead:
 * - setUser -> setUser from authorizationSlice
 * - setUserRole -> setUserRole from authorizationSlice
 * - logout -> logOut from authorizationSlice
 */
export const { setUser, setUserRole, logout, setUserEmail } = userSlice.actions;

export default userSlice.reducer;

